import axios from "./postApi";

export const postPublicFormData = (data = {}) => {
  return axios.post("/savePublicDataForm", data).then((res) => res.data);
};

export const postProfessionalDataForm = (data = {}) => {
  return axios.post("/postProfessionalDataForm", data).then((res) => res.data);
};
